import { render, staticRenderFns } from "./IbanInput.vue?vue&type=template&id=f03fea54&scoped=true"
import script from "./IbanInput.vue?vue&type=script&lang=ts"
export * from "./IbanInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f03fea54",
  null
  
)

export default component.exports